/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import { Divider, IconButton, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import R300DiscountVoucherTableComponent from "./R300DiscountVoucherTableComponent";
import FilterIcon from "mdi-material-ui/FilterOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import EditDeleteTableRecord from "../../../components/EditDeleteTableRecord/EditDeleteTableRecord";
import { HttpRequest } from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

class F300DiscountVoucherReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,

      Data: [],

      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      isLoginMenu: false,
      isReload: false,
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isActive: 0,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      eventDate: date,
    });
  };

  getData = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      console.log("user  response", res);
      if (res.data != null && res.data.length > 0) {
        console.log(" res.DATA", res.data);

        for (var i = 0; i < res.data.length; i++) {
          res.data[i].action = (
            <EditDeleteTableRecord
              recordId={res.data[i].id}
              isActive={res.data[i].isActive}
              handleChangeStatus={(recordId, isActive) =>
                this.handleChangeStatus(recordId, isActive)
              }
              onEditURL={`#/F300DiscountVoucherForm/${res.data[i].id}`}
              handleOpenSnackbar={this.handleOpenSnackbar}
            />
          );
        }
        this.setState({
          Data: res.data || [],
        });
        console.log(" res.DATA AFTER", res.data);
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  // handleChangeStatus = async (recordId, isActive) => {
  //   const data = new FormData();
  //   data.append("id", recordId);
  //   data.append("isActive", isActive);
  //   // const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C06CommonSchoolsDelete`;

  //   const res = await HttpRequest(
  //     "POST",
  //     `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300VoucherActiveStatusUpdate`,
  //     data,
  //     "authorize"
  //   );
  //   console.log(res);
  //   if (res.isSuccess) {
  //     this.handleSnackbar(true, "Status Changed", "success");
  //   } else {
  //     if (res.statusCode === 401) {
  //       this.setState({
  //         isLoginMenu: true,
  //         isReload: false,
  //       });
  //     } else {
  //       this.handleSnackbar(true, res.message, "error");
  //     }
  //   }

  //   // await fetch(url, {
  //   //   method: "POST",
  //   //   body: data,
  //   //   headers: new Headers({
  //   //     Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
  //   //   }),
  //   // })
  //   //   .then((res) => {
  //   //     if (!res.ok) {
  //   //       throw res;
  //   //     }
  //   //     return res.json();
  //   //   })
  //   //   .then(
  //   //     (json) => {
  //   //       if (json.CODE === 1) {
  //   //         this.handleOpenSnackbar("Status Changed", "success");
  //   //       } else {
  //   //         //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
  //   //         this.handleOpenSnackbar(
  //   //           json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
  //   //           "error"
  //   //         );
  //   //       }
  //   //       console.log(json);
  //   //     },
  //   //     (error) => {
  //   //       if (error.status === 401) {
  //   //         this.setState({
  //   //           isLoginMenu: true,
  //   //           isReload: true,
  //   //         });
  //   //       } else {
  //   //         //alert('Failed to fetch, Please try again later.');
  //   //         this.handleOpenSnackbar(
  //   //           "Failed to fetch, Please try again later.",
  //   //           "error"
  //   //         );
  //   //         console.log(error);
  //   //       }
  //   //     }
  //   //   );
  // };

  handleChangeStatus = async (recordId, isActive) => {
    const data = new FormData();
    data.append("id", recordId);
    data.append("isActive", isActive);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300VoucherActiveStatusUpdate`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Status Changed", "success");
      return 1; // ✅ success
    } else {
      if (res.statusCode === 401) {
        this.setState({ isLoginMenu: true, isReload: false });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
      return 0; // ✅ failure — child will revert the toggle
    }
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    // const columnsSubmitted = [
    //     //{ name: "SR#", dataIndex: "serialNo", sortable: false, customStyleHeader: { width: '7%' } },
    //     { name: "Id", dataIndex: "id", sortable: false, customStyleHeader: { width: '8%', textAlign: 'center' } },
    //     {name: "Name", renderer: rowData => { return (<Fragment>{`${rowData.firstName} ${rowData.lastName}`}</Fragment>)}, sortable: false, customStyleHeader: { width: '10%' }},
    //     { name: "Gender", dataIndex: "genderLabel", sortIndex: "genderLabel", sortable: true, customStyleHeader: { width: '12%' } },
    //     { name: "Degree Programme", dataIndex: "degreeLabel", sortIndex: "degreeLabel", sortable: true, customStyleHeader: { width: '17%', textAlign: 'center' }, align: 'center' },
    //     { name: "Mobile No", dataIndex: "mobileNo", sortable: false, customStyleHeader: { width: '13%' } },
    //     { name: "Email", dataIndex: "email", sortable: false, customStyleHeader: { width: '15%' } },
    //     { name: "Submission Date", dataIndex: "submittedOn", sortIndex: "submittedOn", sortable: true, customStyleHeader: { width: '15%' } },
    //     { name: "Payment Method", dataIndex: "paymentMethod", sortIndex: "paymentMethod", sortable: true, customStyleHeader: { width: '15%' } },
    //     { name: "Status", dataIndex: "status", sortIndex: "status", sortable: true, customStyleHeader: { width: '15%' } },
    //     { name: "Profile", renderer: rowData => {return (<Button style={{fontSize: 12,textTransform: 'capitalize'}} variant="outlined" onClick={() => window.open(`#/view-application/${rowData.id}`, "_blank")} >View</Button>)}, sortable: false, customStyleHeader: { width: '15%' }},
    // ]

    const columns = [
      { name: "SRNo", title: "SR#" },
      { name: "isForAll", title: "All/Specific" },
      { name: "voucherLabel", title: "Label" },
      { name: "remarksUser", title: "Description" },
      { name: "voucherCode", title: "Code" },
      { name: "amountStr", title: "Amount" },
      { name: "isStoreWideStr", title: "Store Wide" },
      { name: "Category", title: "Category", wordWrapEnabled: true },
      { name: "isALLProducts", title: "All Products" },
      { name: "product", title: "Products", wordWrapEnabled: true },
      { name: "minAmountCap", title: "Min\xa0Amount" },
      { name: "usageLimitCount", title: "Usage\xa0Limit" },
      {
        name: "effectiveFromStr",
        title: "Effective\xa0From",
        wordWrapEnabled: true,
      },
      {
        name: "effectiveToStr",
        title: "Effective\xa0To",
        wordWrapEnabled: true,
      },
      { name: "notificationMsg", title: "Notification", wordWrapEnabled: true },
      { name: "action", title: "Action" },
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Discount Voucher Report
            </Typography>
            {/* <img alt="" src={ExcelIcon} onClick={() => this.downloadExcelData()} style={{
                            height: 30, width: 32,
                            cursor: `${this.state.isDownloadExcel ? 'wait' : 'pointer'}`,
                        }}
                        /> */}
            <div style={{ float: "right" }}>
              {/* <Hidden xsUp={true}> */}
              {/* <Tooltip title="Search Bar">
                                    <IconButton
                                        onClick={this.handleToggleSearchBar}
                                    >
                                        <FilterIcon fontSize="default" color="primary"/>
                                    </IconButton>
                                </Tooltip> */}
              {/* </Hidden> */}
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                >
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />

          {this.state.Data && (
            <R300DiscountVoucherTableComponent
              data={this.state.Data}
              columns={columns}
              showFilter={this.state.showTableFilter}
            />
          )}
          {/* ) : (
          //   <Grid container justify="center" alignItems="center">
          //     <CircularProgress />
          //   </Grid>
          // )} */}
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}
export default F300DiscountVoucherReport;
